export enum ModelPlatform {
    OPEN_AI = "OPEN_AI",
    ANTHROPIC = "ANTHROPIC",
    GOOGLE_AI = "GOOGLE_AI",
    GROQ_CLOUD = "GROQ_CLOUD",
    TOGETHER = "TOGETHER",
}

export function resolveNameForModelPlatform(platform: ModelPlatform) {
    switch (platform) {
        case ModelPlatform.OPEN_AI:
            return "OpenAI"
        case ModelPlatform.ANTHROPIC:
            return "Anthropic"
        case ModelPlatform.GOOGLE_AI:
            return "Google AI"
        case ModelPlatform.GROQ_CLOUD:
            return "Groq Cloud"
        case ModelPlatform.TOGETHER:
            return "Together AI"
    }
}
